import { useCallback } from 'react';

const useFillOnbaordingInputs = (onboardingOptions, postmortemState, setSelectedOnboardingOptions) => {
  const getDataToFillFor = useCallback((selectOptionsFor) => {

    let selectedOptionsObject = {
      id: "",
      label: "",
      value: "",
    };

    if(postmortemState[selectOptionsFor].label){

      selectedOptionsObject.label = postmortemState[selectOptionsFor].label;
      selectedOptionsObject.value = postmortemState[selectOptionsFor].label;
      selectedOptionsObject.id = postmortemState[selectOptionsFor].id;
    }

    if (onboardingOptions[selectOptionsFor] && onboardingOptions[selectOptionsFor].length > 0) {

      const resultObject = onboardingOptions[selectOptionsFor]?.find(
        (item) => item[`${selectOptionsFor}Name`] === postmortemState[selectOptionsFor].label
      );

      if (resultObject) {

        selectedOptionsObject.id = resultObject[`${selectOptionsFor}Id`];
        selectedOptionsObject.label = resultObject[`${selectOptionsFor}Name`];
        selectedOptionsObject.value = resultObject[`${selectOptionsFor}Name`];
       
      }
    
    }

    return selectedOptionsObject;

  
  }, [onboardingOptions, postmortemState]);

  const setDataFor = useCallback((onboardingField, data) => {
    setSelectedOnboardingOptions((currentSelectedOnboardingOptions) => {
      return {
        ...currentSelectedOnboardingOptions,
        [onboardingField]: data,
      };
    });
  }, [setSelectedOnboardingOptions]);


  return { getDataToFillFor , setDataFor};




};





export default useFillOnbaordingInputs;



